module.exports = __webpack_public_path__ + "media/images/icon__burger-menu@3x-945f2710867ed3904258d59823c11cee.png";